import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { useLocationId } from '@/data/useLocationId';
import { settingsApi } from '../api/settingsApi';
import type { GeneralInfo } from '../api/types';

export function useGeneralInfo() {
  const locationId = useLocationId();
  return useQuery({
    queryKey: keys.settings.general(locationId ?? 0),
    queryFn: ({ signal }) => settingsApi.getGeneralInfo(locationId!, { signal }),
    enabled: locationId != null,
    staleTime: 300_000,
  });
}

export function useUpdateGeneralInfo() {
  const locationId = useLocationId();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<GeneralInfo>) => {
      if (locationId == null) throw new Error('Location required');
      return settingsApi.updateGeneralInfo(locationId, data);
    },
    onSuccess: () => {
      if (locationId != null) {
        void queryClient.invalidateQueries({ queryKey: keys.settings.general(locationId) });
      }
    },
  });
}
